<template>
    <div id="new-waba-channel-form">
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>{{ $t("whatsappChannel.channelName") }}</label>
                    <a-form-item :validate-status="getErrorStatus('channelName')"
                                 :help="getErrorMessage('channelName')">
                        <a-input
                            v-model="form.channelName"
                            :placeholder="this.$t('whatsappChannel.channelName')"
                            name="channelName"
                            ref="channelName"
                        />
                    </a-form-item>
                </div>
                <div class="input-wrapper">
                    <label>API Key </label>
                    <a-input placeholder="API Key " v-model="form.apiKey" v-validate="'required'" name="apiKey" />
                </div>
                <div class="input-wrapper">
                    <label>App ID </label>
                    <a-input placeholder="App ID " v-model="form.appId" v-validate="'required'" name="appId" />
                </div>
                <div class="input-wrapper">
                    <label>Phone Number (E164 Format)</label>
                    <a-input
                        placeholder="Phone Number (E164 Format). ex: 908501234455"
                        v-model="form.phoneNumber"
                        v-validate="'required'"
                        name="phoneNumber"
                    />
                </div>
                <div class="input-wrapper">
                    <div class="mt-1 mb-1">
                        <a-switch :checked="!!form.chatbotStory" @click="toggleChatbot" />
                        <span>👉 Forward to Chatbot</span>
                    </div>

                    <label>Forwarding (Chatbot or Live Agent)</label>
                    <a-select
                        v-model="form.chatbotStory"
                        @change="handleStoryChange"
                        :defaultValue="null"
                        notFoundContent="👉 Forward Live Agents"
                        :disabled="!showStories"
                    >
                        <a-select-option :selected="true" :value="null"> 👉 Forward Live Agents</a-select-option>
                        <a-select-option :key="story._id" v-for="story in stories" :value="story._id">
                            {{ story.title }}
                        </a-select-option>
                    </a-select>
                    <br />
                    <label>Departmana Yönlendirme</label>
                    <a-select v-model="form.allDepartments" @change="getSubjectTitle" :defaultValue="null">
                        <a-select-option :selected="true" value="null">👉Selected Department...</a-select-option>
                        <a-select-option :key="department._id" v-for="department of subjects" :value="department._id">
                            {{ getSubjectTitle(department) }}
                        </a-select-option>
                    </a-select>
                </div>
                <VisibilityChanger v-model="form.visibility" />
            </div>
        </a-form>

        <div class="form-footer">
            <div class="actions">
                <a-button @click="handleCancel">Cancel</a-button>
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading"> Save</a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import VisibilityChanger from "../WhatsappV1/VisibilityChanger.vue";
import _ from "lodash";

export default {
    name: "NewWhatsappBusinessChannel",
    props: {
        channel: {
            type: Object,
            default: () => {
            },
        },
    },
    components: {
        VisibilityChanger,
    },
    data() {
        return {
            showStories: false,
            alldepartments: [],
            form: {
                channelName: "",
                apiKey: "",
                appId: "",
                phoneNumber: "",
                chatbotStory: null,
            },
            loading: false,
            clone: _.cloneDeep(this.channel),
            submitClicked: false,
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            subjects: (state) => _.get(state.subject.subjects, "data", []) || [],
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
        }),
        getErrorStatus(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? "error" : "";
        },
        getErrorMessage(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? this.$t("message.requiredChannel") : "";
        },
        toggleChatbot() {
            if (this.showStories) {
                this.form.chatbotStory = null;
            } else {
                if (this.stories[0]) {
                    this.form.chatbotStory = this.stories[0]._id;
                }
            }
            this.showStories = !this.showStories;
        },
        handleStoryChange() {
        },
        getSubjectTitle(department) {
            const validLangs = Object.keys(department.languageContent);
            const targetLang = validLangs.includes(this.$i18n.locale) ? this.$i18n.locale : validLangs[0];
            const key = `languageContent.${targetLang}.name`;
            return _.get(department, key);
        },
        handleCancel() {
            this.$emit("cancel");
        },
        handleSave() {
            this.submitClicked = true;
            if (this.form.channelName.length < 1) {
                this.$refs.channelName.focus();
                return;
            } else {
                const isValid = true;
                if (isValid) {
                    const payload = {
                        type: "whatsapp-business-api",
                        name: this.form.channelName,
                        chatbotStory: this.form.chatbotStory,
                        payload: {
                            apiKey: this.form.apiKey,
                            appId: this.form.appId,
                            phoneNumber: this.form.phoneNumber,
                        },
                    };
                    this.loading = true;
                    this.createChannel(payload)
                        .then(() => {
                            this.$message.success("Channel created successfully");
                            this.$emit("ok");
                        })
                        .catch((err) => {
                            this.$message.error("Failed to create channel");
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            }
        },
    },
    mounted() {
    },
    beforeDestroy() {
    },
};
</script>

<style lang="scss" scoped>
#new-waba-channel-form {
    min-height: 250px;
    flex-direction: column;

    .form-wrapper {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;
        }
    }

    .form-footer {
        display: flex;
        justify-content: flex-end;
        padding: 10px;
        margin-top: 20px;
        background: var(--color-bg-default);
        border-top: 1px solid var(--color-border-default);
    }
}
</style>

<style lang="scss">
.new-waba {
    .custom-modal-body {
        padding: 0px !important;
    }
}
</style>
